<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="8" md="8">
        <SubmitSchedule />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat color="white">
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
              Today
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar class="text-capitalize" ref="calendar" v-model="focus" color="primary" :events="events"
            :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
            @click:date="viewDay" @change="updateRange">
          </v-calendar>
          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
            <v-card color="grey lighten-4" class="mx-auto" width="450px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-toolbar-title class="text-capitalize" v-html="selectedEvent.name"></v-toolbar-title>
              </v-toolbar>
              <v-card-text v-if="selectedEvent.name == 'Unscheduled'">
                <span>This schedule is not yet either approved by the secretary or
                  <br />
                  No user has set appointment yet on this slot</span>
              </v-card-text>
              <v-card-text>
                <span>Click here for the
                  <a :href="selectedEvent.details">Meeting URL</a></span>
              </v-card-text>
              <v-card-text v-if="selectedEvent.name != 'Unscheduled'">
                <v-list color="grey lighten-4" density="compact">
                  <v-list-item @click="showReasonDialog = true">
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="selectedEvent.reason == null"> None </span>
                        {{ selectedEvent.reason }}
                      </v-list-item-title>
                      <v-list-item-subtitle>Reason for consult</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon color="blue-grey">
                        mdi-open-in-new
                      </v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item @click="showSelectedUserDetails = true">
                    <v-list-item-content>
                      <v-list-item-title>Client details</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon color="blue-grey">
                        mdi-open-in-new
                      </v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-group :value="false">
                    <template v-slot:activator>
                      <v-list-item-title>Client appointments</v-list-item-title>
                    </template>

                    <v-list-item v-for="clientSchedule in selectedEvent.client_schedules"
                      :key="clientSchedule.start_date">
                      <v-list-item-content>
                        <v-list-item-title> {{ clientSchedule.start_date }}</v-list-item-title>
                        <v-list-item-subtitle>{{ clientSchedule.reason }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <div class="text-center">
                  <v-dialog v-model="deleteDialog" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                        Delete
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Warning
                      </v-card-title>

                      <v-card-text>
                        This will delete this schedule slot. Please click
                        "Continue" if you want to proceed.
                      </v-card-text>

                      <v-progress-linear indeterminate color="cyan" v-if="isDeleting"></v-progress-linear>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-btn color="primary" text @click="deleteDialog = false">
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" text @click="deleteSchedule(selectedEvent.id)">
                          Continue
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-dialog v-model="meetingUrlDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            UPDATE MEETING LINK
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">Update Meeting Link</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-text-field label="Please input either zoom or google meets meeting link" v-model="updatedMeetingUrl"
                  required></v-text-field>
              </v-row>
              <v-progress-linear indeterminate color="cyan" v-if="isSending"></v-progress-linear>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="meetingUrlDialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="updateMeetingUrl">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showReasonDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Consult Reason</v-card-title>
          <v-card-text>
            {{ selectedEvent.reason || 'No reason provided.' }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showReasonDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showSelectedUserDetails" max-width="500">
        <v-card>
          <v-img height="250" :src="selectedEvent.profile_image_url" cover></v-img>
          <v-card-title class="headline text-capitalize"> {{ selectedEvent.name }}</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-phone
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> {{ selectedEvent.mobile_number }}</v-list-item-title>
                  <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-at
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> {{ selectedEvent.email }}</v-list-item-title>
                  <v-list-item-subtitle>Email</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-gender-male-female
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ selectedEvent.gender }}</v-list-item-title>
                  <v-list-item-subtitle>Gender</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-calendar-range
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ selectedEvent.birth_date }}</v-list-item-title>
                  <v-list-item-subtitle>Date of Birth</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-face-recognition
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ selectedEvent.age }}</v-list-item-title>
                  <v-list-item-subtitle>Date of Birth</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-map-marker
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>{{ selectedEvent.address }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>Address</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="blue-grey">
                    mdi-badge-account
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ selectedEvent.civil_status }}</v-list-item-title>
                  <v-list-item-subtitle>Civil Status</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showSelectedUserDetails = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import {
  get_service_provider_schedules,
  post_service_provider_schedule,
  put_meeting_url,
  get_service_provider_meeting_url,
  delete_service_provider_schedule,
} from "../api";
import SubmitSchedule from "./SubmitSchedule";
import store from "../store";


export default {
  components: {
    SubmitSchedule,
  },
  data: () => ({
    showSelectedUserDetails: false,
    showReasonDialog: false,

    start_time: moment("10:00", "HH:mm").format("HH:mm"),
    start_time_modal: false,

    end_time: moment("21:00", "HH:mm").format("HH:mm"),
    end_time_modal: false,

    from_date: new Date().toISOString().substring(0, 10),
    to_date: new Date().toISOString().substring(0, 10),

    menu_1: false,
    menu_2: false,

    isDeleting: false,
    isSending: false,
    deleteDialog: false,

    meeting_url: "",
    updatedMeetingUrl: "",
    is_update_meeting_url: false,

    loader: null,
    loading: false,

    meetingUrlDialog: false,

    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange"],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
  }),
  mounted() {
    this.$refs.calendar.checkChange();
    const jwt = store.getters.getJwt;
    get_service_provider_meeting_url(jwt).then((response) => {
      this.updatedMeetingUrl = response.data.sp_meeting_url;
    });
  },
  methods: {
    calculateAge(birthDate) {
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        console.table(event);
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    deleteSchedule(schedule_id) {
      const jwt = store.getters.getJwt;
      this.isDeleting = true;
      delete_service_provider_schedule(jwt, { schedule_id }).then(() => {
        this.deleteDialog = false;
        this.isDeleting = false;
        this.$router.go();
      });
    },
    updateMeetingUrl() {
      const jwt = store.getters.getJwt;
      this.isSending = true;
      put_meeting_url(jwt, { meeting_url: this.updatedMeetingUrl }).then(() => {
        this.meetingUrlDialog = false;
        this.isSending = false;
        this.$router.go();
      });
    },
    updateRange({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const jwt = store.getters.getJwt;
      get_service_provider_schedules(
        jwt,
        min.toISOString(),
        max.toISOString()
      ).then((response) => {
        const scheds = response.data.schedules;
        scheds.forEach((sched) => {
          var color;
          var clientName;
          // Display still the "New" and "Pending Approval" schedules
          if (sched.state == "New" || sched.state == "Pending Approval") {
            color = "grey darken-1";
            clientName = "Unscheduled";
          } else {
            color = this.colors[this.rnd(0, this.colors.length - 1)];
            clientName = sched.name;
          }

          let clientScheduleList = []
          for (let cs of sched.client_schedule) {
            clientScheduleList.push({
              start_date: moment(cs.start).format('lll').toString(),
              reason: cs.reason,
            })
          }

          events.push({
            id: sched.id,
            name: clientName,
            email: sched.email,
            mobile_number: sched.mobile_number,
            reason: sched.reason,
            details: sched.meeting_url,
            gender: sched.gender,
            address: sched.address,
            birth_date: new Date(sched.birth_date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }),
            profile_image_url: sched.profile_image_url,
            age: this.calculateAge(sched.birth_date),
            civil_status: sched.civil_status,
            educational_attainment: sched.educational_attainment,
            start: new Date(sched.start),
            end: new Date(sched.end),
            color: color,
            timed: true, // This is to display the time
            client_schedules: clientScheduleList,
          });
        });
      });
      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      // This is to eliminate for sending the payload twice since watch for loader value will be modified twice
      // exit if the loader variable is set to null
      if (!this.loader) {
        this.$router.go();
        return;
      }

      const start_date = new moment(`${this.from_date}T${this.start_time}`);
      const end_date = new moment(`${this.to_date}T${this.end_time}`);
      const schedule = {
        start_date: start_date.toISOString(),
        end_date: end_date.toISOString(),
        meeting_url: this.meeting_url,
      };

      const jwt = store.getters.getJwt;
      post_service_provider_schedule(jwt, schedule).then(() => {
        this[l] = false;
      });

      this.loader = null;
    },
  },
};
</script>
<style scoped>
.controls {
  position: relative;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
